import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=04394c71&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=ts&"
export * from "./Mobile.vue?vue&type=script&lang=ts&"
import style0 from "./Mobile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Mobile.vue?vue&type=style&index=1&id=04394c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04394c71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VMain,VProgressCircular})
